/**
 * A single settings card slot: its header, plus whatever `children` its
 * content owner passes.
 *
 * Seven of these, in a fixed order, are the whole pool settings screen body.
 * This component is never handed an empty slot any more: `visibleSlotsForRole`
 * drops a slot whose content has not been built, so a header-only card cannot
 * reach the screen. `children` stays optional only because the branch that
 * fills it lives in the parent.
 *
 * Content owners, as of this writing: ISSUE-201 (Pool, filled), ISSUE-192
 * (Joining, filled), ISSUE-200 (Contest rules, filled), ISSUE-501 (Season,
 * filled), ISSUE-482 (Awards, filled), ISSUE-1040 (Chat, filled), ISSUE-817
 * (Danger zone, filled), ISSUE-1042 (Contests, filled), ISSUE-490
 * (Notifications, unbuilt). Members has no filed owner: ISSUE-817's member
 * role actions shipped on the members pane at `/pools?view=members`, not in a
 * settings card, so nothing is planned for the `members` slot here.
 */
import { Card, cn } from "@sportsmet/ui";
import type { ReactNode } from "react";

import type { typePoolSettingsSlot } from "./poolSettingsState";

export type typePoolSettingsCardSlotProps = {
  slot: typePoolSettingsSlot;
  /** True when `?panel=` names this slot. Deep-link target marker only. */
  isActive: boolean;
  /** The slot's content. Omitted while the panel's owning issue is unbuilt. */
  children?: ReactNode | undefined;
};

export const PoolSettingsCardSlot = ({
  slot,
  isActive,
  children,
}: typePoolSettingsCardSlotProps): ReactNode => {
  return (
    <Card
      title={slot.title}
      data-testid={`pool-settings-slot-${slot.panel}`}
      data-active={isActive ? "true" : undefined}
      tone={slot.isDanger ? "error" : "default"}
      className={cn(slot.isDanger && "mt-6")}
    >
      {children}
    </Card>
  );
};
